const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaCnhCategoria: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MOTORISTA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'MOTORISTA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'MOTORISTA_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome,
                    id_transportadora: item.id_transportadora
                }))
            };

        case 'MOTORISTA_CNH_CATEGORIA_LISTADO':
                 
			return { ...state, listaCnhCategoria: action.payload.data };

        default:
            return state;
    }
}
